import {
  EKYCStatus,
  ESSNVerificationStatus,
  publicPaginationSchema,
  publicSortSchema,
  schemes,
  zSchema,
} from "@zeal/common";

export const getMyWorkersRequestSchema = zSchema.object({
  query: zSchema.object({
    default_pay_schedule: zSchema.string().optional(),
    employment_status: zSchema.string().optional(),
    fetchBank: zSchema.boolean().optional(),
    is_regular: zSchema.boolean().optional(),
    isOnboarded: zSchema.boolean().optional(),
    q: zSchema.string().optional(),
  }),
  ...publicPaginationSchema.shape,
  ...publicSortSchema.shape,
});

export type TGetMyWorkersRequestSchema = zSchema.infer<
  typeof getMyWorkersRequestSchema
>;

export const getMyWorkersResponseSchema = zSchema.array(
  zSchema.object({
    _id: schemes.mongoObjectId(),
    address: zSchema.string(),
    address_line2: zSchema.string(),
    autopilot_on: zSchema.boolean(),
    bankAccountID: schemes.mongoObjectId(),
    city: zSchema.string(),
    companyID: schemes.companyID(),
    complete_paperwork: zSchema.boolean(),
    createdAt: schemes.isoDate(),
    default_dt_wage: zSchema.number(),
    default_ot_wage: zSchema.number(),
    default_pay_schedule: zSchema.string(),
    default_wage: zSchema.number(),
    dob: schemes.isoDate(),
    email: schemes.email(),
    employeeRequirementsLink: zSchema.string(),
    employment_status: zSchema.string(),
    first_name: zSchema.string(),
    full_name: zSchema.string(),
    is_943: zSchema.boolean(),
    is_regular: zSchema.boolean(),
    is_salary: zSchema.boolean(),
    is_scheduleH: zSchema.boolean(),
    kyc_status: zSchema.nativeEnum(EKYCStatus),
    last_name: zSchema.string(),
    middle_name: zSchema.string(),
    onboard_docs_faxed: zSchema.boolean(),
    onboarded: zSchema.boolean(),
    openRequirements: zSchema.number(),
    organization: zSchema.string(),
    payroll_results: zSchema.array(zSchema.any()),
    phone_number: zSchema.string(),
    pto: zSchema.array(zSchema.any()),
    // @TODO(todd): why are these null?
    salary: zSchema.null(),
    salary_firstDate: zSchema.null(),
    ssn: zSchema.string(),
    ssn_verification_status: zSchema
      .nativeEnum(ESSNVerificationStatus)
      .optional(),
    start_date: schemes.isoDate(),
    state: zSchema.string(),
    taxengine_workerID: zSchema.string(),
    title: zSchema.string(),
    updatedAt: schemes.isoDate(),
    user_type: zSchema.string(),
    vac: zSchema.array(zSchema.any()),
    workLocationID: schemes.mongoObjectId(),
    working_state: zSchema.string(),
    zip: zSchema.string(),
    is_owner: zSchema.boolean(),
  })
);

export type TGetMyWorkersResponseSchema = zSchema.infer<
  typeof getMyWorkersResponseSchema
>;
